import { Languages } from 'lucide-react';
import { cn } from '@/lib/utils';
import { LANGUAGE_OPTIONS, TOUR_TEXT, type TourLanguage } from './tour-language';

export function TourLanguageSwitch({
  language,
  onChange,
}: {
  language: TourLanguage;
  onChange: (next: TourLanguage) => void;
}) {
  return (
    <div role="group" aria-label={TOUR_TEXT[language].languageLabel} className="inline-flex items-center gap-1 rounded-full border bg-muted/60 p-1">
      <Languages className="ms-2 h-3.5 w-3.5 text-muted-foreground" aria-hidden />
      {LANGUAGE_OPTIONS.map((option) => (
        <button
          key={option.id}
          type="button"
          aria-pressed={option.id === language}
          onClick={() => onChange(option.id)}
          className={cn(
            'rounded-full px-3 py-1 text-xs font-medium transition-colors focus-ring',
            option.id === language ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:text-foreground',
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
